import { useEffect } from 'react';

const DEFAULT_TITLE =
  'GENSOL - Renta de Generadores Eléctricos en Veracruz | Torres de Iluminación y Soldadoras';

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

// Direct-DOM SEO tags (react-helmet 6.x is unreliable with React 18)
const Seo = ({ title, description, canonical, ogType = 'website', ogImage }) => {
  useEffect(() => {
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', ogType);
    setMeta('property', 'og:url', canonical);
    if (ogImage) setMeta('property', 'og:image', ogImage);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonical);

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description, canonical, ogType, ogImage]);

  return null;
};

export default Seo;
